/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  FundingRequestPayoutGroupItemDto,
  FundingRequestPayoutGroupItemDtoFromJSON,
  FundingRequestPayoutGroupItemDtoFromJSONTyped,
  FundingRequestPayoutGroupItemDtoToJSON,
} from "./FundingRequestPayoutGroupItemDto";

/**
 *
 * @export
 * @interface FundingRequestPayoutGroupRequestDto
 */
export interface FundingRequestPayoutGroupRequestDto {
  /**
   *
   * @type {Array<FundingRequestPayoutGroupItemDto>}
   * @memberof FundingRequestPayoutGroupRequestDto
   */
  payouts: Array<FundingRequestPayoutGroupItemDto>;
}

export function FundingRequestPayoutGroupRequestDtoFromJSON(json: any): FundingRequestPayoutGroupRequestDto {
  return FundingRequestPayoutGroupRequestDtoFromJSONTyped(json, false);
}

export function FundingRequestPayoutGroupRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestPayoutGroupRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    payouts: (json["payouts"] as Array<any>).map(FundingRequestPayoutGroupItemDtoFromJSON),
  };
}

export function FundingRequestPayoutGroupRequestDtoToJSON(value?: FundingRequestPayoutGroupRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    payouts: (value.payouts as Array<any>).map(FundingRequestPayoutGroupItemDtoToJSON),
  };
}
